module.exports = __webpack_public_path__ + "img/daycare_thumbnail-400x300.5eb2343a.jpg";